import React from 'react'
import { Link } from 'gatsby'
import {
  Wrap,
  LargeColLeft,
  LargeColRight,
  LargeColOnLeft,
  SmallColOnRight,
  ColRight,
  FullCentered,
  RemainingSideRight,
  spacedVertical,
  spacedHorizontal,
} from '@/styles/Layout'

import styled from 'styled-components'
import PostImage from './PostImage'
import PostFormattedTitle from './PostFormattedTitle'
import IconPlay from '@/components/Featured/Mundial62/Logo/IconPlay'
import PostExcerpt from './PostExcerpt'
import TxtVermas from '@/components/Featured/Mundial62/Logo/TxtVermas'

const PostWrap = styled(Wrap)`
  ${spacedVertical}
  h1 {
    a {
      color: #2a0b0e;
      span {
        text-decoration-line: underline;
        text-decoration-thickness: 2rem;
        text-decoration-style: solid;
        text-underline-offset: -0.6rem;
        text-decoration-color: #f45115;
      }
    }
  }
`

const More = styled(RemainingSideRight)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

const ImageLink = styled(Link)`
  position: relative;
  display: block;
`

const IconWrap = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
`

const VerMasBtn = styled(TxtVermas)`
  width: 100%;
  max-width: 10vw;
  @media (max-width: 1200px) {
    max-width: 15vw;
  }
  @media (max-width: 768px) {
    max-width: 20vw;
  }
  @media (max-width: 480px) {
    max-width: 30vw;
  }
`

const PostHeader = ({
  title,
  pretitle,
  posttitle,
  largesttitle,
  layout = 'base',
  author,
  authorsite,
  authorsiteurl,
  date,
  slug,
  featuredImage,
  excerpt,
  withPostImage = true,
  withLink = true,
  videoFormat = false,
  visualFields,
}) => {
  const { accentcolor, maincolor, secondarycolor, schema } = visualFields

  return (
    <PostWrap as="article">
      {withPostImage && (
        <FullCentered>
          <ImageLink to={`/${slug}/`}>
            <PostImage image={featuredImage} />
            {videoFormat && (
              <IconWrap>
                <IconPlay />
              </IconWrap>
            )}
          </ImageLink>
        </FullCentered>
      )}

      <LargeColOnLeft>
        <PostFormattedTitle
          to={`/${slug}/`}
          title={title}
          pretitle={pretitle}
          posttitle={posttitle}
          largesttitle={largesttitle}
        />
      </LargeColOnLeft>
      <More>
        <Link to={`/${slug}/`} className="block">
          <VerMasBtn mainColor={maincolor} accentColor={accentcolor} />
        </Link>
      </More>
      <LargeColRight>
        <PostExcerpt excerpt={excerpt} to={`/${slug}/`} withLink={true} />
      </LargeColRight>
    </PostWrap>
  )
}

export default PostHeader
